export const AUTH_TOKEN = "auth-token";
export const USER_LOG_IN_DETAIL = "userSignUpDetail";
export const AUTH_EXPIRY = "authExp";